import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes, FirmAssetBalanceStatistics } from '@tassat/fred-definitions';

export interface FirmAssetBalanceStatisticsState {
    [key: string]: {
        [key: string]: FirmAssetBalanceStatistics;
    };
}

const initialState: FirmAssetBalanceStatisticsState = {};

const initialLoadAction = createAction<{ firmAssetBalanceStats: FirmAssetBalanceStatisticsState }>('InitialLoad');
const firmAssetBalanceStatisticsAction = createAction<FirmAssetBalanceStatistics>(CoreMsgTypes.FirmAssetBalanceStatistics);

const firmAssetBalanceStatsSlice = createSlice({
    name: 'firmAssetBalanceStats',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (state, action) => {
                Object.assign(state, action.payload.firmAssetBalanceStats);
            })
            .addCase(firmAssetBalanceStatisticsAction, (state, action) => {
                const { FirmId, AssetId } = action.payload;
                if (!state[FirmId]) state[FirmId] = {};
                state[FirmId][AssetId] = {
                    ...state[FirmId][AssetId],
                    // TODO Check server msg: the real time record
                    // does not have the same properties as the
                    // inital load record
                    ...action.payload
                };
            });
    }
});

export default firmAssetBalanceStatsSlice.reducer;